/* eslint-env node */

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { createInertiaApp, Link } from '@inertiajs/vue3';
import { createApp, h } from 'vue';
import i18n from './i18n';
import VueConfetti from 'vue-confetti';
import VueApexCharts from 'vue3-apexcharts';
import en from 'apexcharts/dist/locales/en.json';
import es from 'apexcharts/dist/locales/es.json';
import ca from 'apexcharts/dist/locales/ca.json';
import './bootstrap';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import GlobalSearch from '@/components/GlobalSearch.vue';
import BreadcrumbDropdownButton from '@/components/BreadcrumbDropdownButton.vue';
import InertiaLinkButton from '@/components/InertiaLinkButton.vue';
import 'tippy.js/dist/tippy.css';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import * as MathfieldElement from 'mathlive';
import HoneybadgerVue from '@honeybadger-io/vue';

window.Apex.chart = {
    locales: [en, es, ca],
    defaultLocale: document.documentElement.lang || 'es',
};

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// noinspection JSIgnoredPromiseFromCall
createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`),
    progress: {
        color: '#5f6db1',
    },
    setup({ el, App, props, plugin }) {
        createApp({
            render: () => h(App, props),
        })
            .use(VueApexCharts)
            .use(i18n)
            .use(plugin)
            .use(VueConfetti)
            .use(HoneybadgerVue, {
                apiKey: process.env.MIX_HONEYBADGER_API_KEY,
                environment: process.env.MIX_HONEYBADGER_ENVIRONMENT,
                revision: 'master',
            })
            .use(autoAnimatePlugin)
            .use(MathfieldElement)
            .mixin({ methods: { route } })
            .component('breadcrumb-dropdown-button', BreadcrumbDropdownButton)
            .component('GlobalSearch', GlobalSearch)
            .component('InertiaLinkButton', InertiaLinkButton)
            .component('SmartBreadcrumbs', SmartBreadcrumbs)
            .component('InertiaLink', Link)
            .mount(el);
    },
});
